import { gql } from '@apollo/client';

/**
 * Query para obtener todos los tenants del sistema
 * Solo SuperAdmin
 */
export const FETCH_TENANTS = gql`
  query FetchTenants {
    tenants {
      id
      name
      code
      isActive
      createdAt
      updatedAt
    }
  }
`;

/**
 * Query para obtener todas las configuraciones de un tenant específico
 * Solo SuperAdmin - para panel de administración cross-tenant
 */
export const GET_ALL_CONFIGS_FOR_TENANT = gql`
  query GetAllConfigsForTenant($tenantId: ID!) {
    getAllConfigsForTenant(tenantId: $tenantId)
  }
`;

/**
 * Query para obtener el AppConfig CRUDO de un tenant (solo sus overrides,
 * SIN mergear con los defaults del catálogo). Para detección de origen
 * (badge override/default) en el panel admin. Solo SuperAdmin
 */
export const APP_CONFIG_FOR_TENANT = gql`
  query AppConfigForTenant($tenantId: ID!) {
    appConfigForTenant(tenantId: $tenantId) {
      id
      settings
      tenantId
    }
  }
`;

/**
 * Query para obtener el catálogo global de feature flags
 * Solo SuperAdmin
 */
export const FETCH_FEATURE_FLAGS = gql`
  query FetchFeatureFlags {
    featureFlags {
      id
      key
      description
      defaultValue
      isActive
      createdAt
      updatedAt
    }
  }
`;
